// extracted by mini-css-extract-plugin
module.exports = {"container":"block-module--container--28ujx","icon":"block-module--icon--AA7xn","value":"block-module--value--2_ylT"};